import { resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, withKeys as _withKeys, vModelText as _vModelText, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["placeholder"]
const _hoisted_2 = ["data-tooltip", "aria-label"]
const _hoisted_3 = ["data-tooltip", "aria-label"]
const _hoisted_4 = ["data-tooltip", "aria-label"]

export function render(_ctx, _cache) {
  const _component_InfoPanel = _resolveComponent("InfoPanel")

  return (_openBlock(), _createElementBlock("footer", {
    class: _normalizeClass([
    _ctx.getClass('inputContainer'),
    _ctx.disableInput ? _ctx.getClass('hide') : '',
    _ctx.getClass('inputContainer--two-row')
  ])
  }, [
    _createVNode(_Transition, {
      name: "satisfi_info-panel",
      persisted: ""
    }, {
      default: _withCtx(() => [
        _withDirectives(_createVNode(_component_InfoPanel, null, null, 512 /* NEED_PATCH */), [
          [_vShow, _ctx.showInfoPanel]
        ])
      ]),
      _: 1 /* STABLE */
    }),
    _createCommentVNode(" SD-4292: role=\"form\" is not needed here.\r\n        Fix: Values assigned to role=\"\" are not valid ARIA roles.\r\n        The HTML <form> element is sufficient to tell assistive technologies that there is a form.\r\n        Reference: https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Roles/form_role   "),
    _createElementVNode("form", {
      onSubmit: _cache[10] || (_cache[10] = _withModifiers(() => {}, ["prevent"]))
    }, [
      _createCommentVNode(" [1] Chat Text Box "),
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.getClass('textareaContainer'))
      }, [
        _withDirectives(_createElementVNode("textarea", {
          "aria-controls": "divChatBody",
          ref: "input",
          onKeydown: _cache[0] || (_cache[0] = _withKeys(_withModifiers((...args) => (_ctx.onEnterPressHandler && _ctx.onEnterPressHandler(...args)), ["exact","prevent"]), ["enter"])),
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((_ctx.inputData) = $event)),
          placeholder: _ctx.inputPlaceHolder,
          class: _normalizeClass(_ctx.getClass('textInput ') + _ctx.getClass('textAreaInput')),
          "aria-label": "Ask a question",
          onKeyup: _cache[2] || (_cache[2] = (...args) => (_ctx.sendTypingIndicator && _ctx.sendTypingIndicator(...args))),
          tabindex: "0",
          spellcheck: "false",
          onFocus: _cache[3] || (_cache[3] = (...args) => (_ctx.autoResize && _ctx.autoResize(...args))),
          onBlur: _cache[4] || (_cache[4] = (...args) => (_ctx.onChatTextBoxBlur && _ctx.onChatTextBoxBlur(...args))),
          rows: "1",
          style: _normalizeStyle(_ctx.inputStyle),
          autocomplete: "off"
        }, "\t\t\t", 46 /* CLASS, STYLE, PROPS, NEED_HYDRATION */, _hoisted_1), [
          [_vModelText, _ctx.inputData]
        ]),
        _withDirectives(_createElementVNode("textarea", {
          class: _normalizeClass(_ctx.getClass('textAreaShadow')),
          "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => ((_ctx.inputData) = $event)),
          ref: "shadow",
          tabindex: "-1",
          "aria-hidden": "true",
          autocomplete: "off",
          "aria-label": "hidden"
        }, null, 2 /* CLASS */), [
          [_vModelText, _ctx.inputData]
        ])
      ], 2 /* CLASS */),
      _createCommentVNode(" [2] Action Buttons "),
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.getClass('btnGroup'))
      }, [
        _withDirectives(_createElementVNode("button", {
          type: "button",
          onClick: _cache[6] || (_cache[6] = _withModifiers((...args) => (_ctx.onLanguageBtnClick && _ctx.onLanguageBtnClick(...args)), ["prevent"])),
          class: _normalizeClass(_ctx.getClass('btn ')+ _ctx.getClass('language ') + _ctx.getClass('tooltip')),
          "data-tooltip": _ctx.languageSelectorTooltip,
          "aria-label": _ctx.languageSelectorTooltip,
          tabindex: "0"
        }, _cache[11] || (_cache[11] = [
          _createElementVNode("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 32 32",
            width: "18",
            height: "18"
          }, [
            _createElementVNode("path", {
              d: "M16 2a14 14 0 1 0 14 14A14 14 0 0 0 16 2zm11.84 12.11h-.07A19.62 19.62 0 0 1 24 15.79a19.27 19.27 0 0 0-2.88-10.63 12 12 0 0 1 6.72 8.95zM10 16c0-5.82 2.2-10.83 5-11.81V17a26 26 0 0 1-5-.64V16zm5 3v8.84c-2.4-.85-4.37-4.65-4.87-9.41A28.57 28.57 0 0 0 15 19zm2 8.84V19a28.57 28.57 0 0 0 4.87-.57c-.5 4.73-2.47 8.57-4.87 9.38zM17 17V4.19c2.8 1 5 6 5 11.81v.33a26 26 0 0 1-5 .67zM10.88 5.16A19.27 19.27 0 0 0 8 15.79a19.62 19.62 0 0 1-3.78-1.65h-.07a12 12 0 0 1 6.73-8.98zM4 16.28a22.26 22.26 0 0 0 4.07 1.61 18.36 18.36 0 0 0 2.8 9A12 12 0 0 1 4 16.28zm17.12 10.56a18.36 18.36 0 0 0 2.8-8.95A22.26 22.26 0 0 0 28 16.28a12 12 0 0 1-6.88 10.56z",
              fill: "#B4B4B4",
              "fill-rule": "evenodd"
            })
          ], -1 /* HOISTED */)
        ]), 10 /* CLASS, PROPS */, _hoisted_2), [
          [_vShow, _ctx.showLanguageBtn]
        ]),
        _withDirectives(_createElementVNode("button", {
          type: "button",
          onClick: _cache[7] || (_cache[7] = _withModifiers((...args) => (_ctx.showTranscriptModal && _ctx.showTranscriptModal(...args)), ["prevent"])),
          class: _normalizeClass(_ctx.getClass('btn ')+ _ctx.getClass('transcript ') + _ctx.getClass('tooltip')),
          "data-tooltip": _ctx.transcriptTooltip,
          "aria-label": _ctx.transcriptTooltip,
          tabindex: "0"
        }, _cache[12] || (_cache[12] = [
          _createElementVNode("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            id: "transcript_icon",
            viewBox: "0 0 24 24",
            width: "16",
            height: "16",
            alt: "Send transcript"
          }, [
            _createElementVNode("path", {
              d: "M19,1H5A5.006,5.006,0,0,0,0,6V18a5.006,5.006,0,0,0,5,5H19a5.006,5.006,0,0,0,5-5V6A5.006,5.006,0,0,0,19,1ZM5,3H19a3,3,0,0,1,2.78,1.887l-7.658,7.659a3.007,3.007,0,0,1-4.244,0L2.22,4.887A3,3,0,0,1,5,3ZM19,21H5a3,3,0,0,1-3-3V7.5L8.464,13.96a5.007,5.007,0,0,0,7.072,0L22,7.5V18A3,3,0,0,1,19,21Z",
              fill: "#B4B4B4",
              "fill-rule": "evenodd"
            })
          ], -1 /* HOISTED */)
        ]), 10 /* CLASS, PROPS */, _hoisted_3), [
          [_vShow, _ctx.showTranscriptBtn]
        ]),
        _withDirectives(_createElementVNode("button", {
          onClick: _cache[8] || (_cache[8] = _withModifiers((...args) => (_ctx.showInfo && _ctx.showInfo(...args)), ["prevent"])),
          class: _normalizeClass(_ctx.getClass('btn ')+ _ctx.getClass('info ') + _ctx.getClass('tooltip')),
          "data-tooltip": _ctx.infoButtonTooltip,
          "aria-label": _ctx.infoButtonTooltip,
          tabindex: "0"
        }, _cache[13] || (_cache[13] = [
          _createElementVNode("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 24 24",
            width: "16",
            height: "16",
            alt: "Chat options and preferences"
          }, [
            _createElementVNode("g", {
              id: "info_align_center",
              "data-name": "info align center"
            }, [
              _createElementVNode("path", {
                d: "M12,24A12,12,0,1,1,24,12,12.013,12.013,0,0,1,12,24ZM12,2A10,10,0,1,0,22,12,10.011,10.011,0,0,0,12,2Z",
                fill: "#B4B4B4",
                "fill-rule": "evenodd"
              }),
              _createElementVNode("path", {
                d: "M14,19H12V12H10V10h2a2,2,0,0,1,2,2Z",
                fill: "#B4B4B4",
                "fill-rule": "evenodd"
              }),
              _createElementVNode("circle", {
                cx: "12",
                cy: "6.5",
                r: "1.5"
              })
            ])
          ], -1 /* HOISTED */)
        ]), 10 /* CLASS, PROPS */, _hoisted_4), [
          [_vShow, _ctx.showInfoBtn]
        ]),
        _withDirectives(_createElementVNode("button", {
          class: _normalizeClass(_ctx.getClass('btn ') + _ctx.getClass('camera ')  + _ctx.getClass ('tooltip')),
          "data-tooltip": "Upload or take a photo",
          "aria-label": "Upload or take a photo",
          tabindex: "0"
        }, _cache[14] || (_cache[14] = [
          _createElementVNode("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            id: "camera_icon",
            viewBox: "0 0 24 24",
            width: "16",
            height: "16",
            alt: "Upload or take a photo"
          }, [
            _createElementVNode("path", {
              d: "M19,4h-.508L16.308,1.168A3.023,3.023,0,0,0,13.932,0H10.068A3.023,3.023,0,0,0,7.692,1.168L5.508,4H5A5.006,5.006,0,0,0,0,9V19a5.006,5.006,0,0,0,5,5H19a5.006,5.006,0,0,0,5-5V9A5.006,5.006,0,0,0,19,4ZM9.276,2.39A1.006,1.006,0,0,1,10.068,2h3.864a1.008,1.008,0,0,1,.792.39L15.966,4H8.034ZM22,19a3,3,0,0,1-3,3H5a3,3,0,0,1-3-3V9A3,3,0,0,1,5,6H19a3,3,0,0,1,3,3Z",
              fill: "#b4b4b4",
              "fill-rule": "evenodd"
            }),
            _createElementVNode("path", {
              d: "M12,8a6,6,0,1,0,6,6A6.006,6.006,0,0,0,12,8Zm0,10a4,4,0,1,1,4-4A4,4,0,0,1,12,18Z",
              fill: "#b4b4b4",
              "fill-rule": "evenodd"
            })
          ], -1 /* HOISTED */)
        ]), 2 /* CLASS */), [
          [_vShow, _ctx.showCameraBtn]
        ])
      ], 2 /* CLASS */),
      _createCommentVNode(" [3] Send Button "),
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.getClass('inputContainer__send'))
      }, [
        _createElementVNode("button", {
          type: "button",
          ref: "sendButton",
          class: _normalizeClass(_ctx.getClass('btn ') + _ctx.getClass('send')),
          onClick: _cache[9] || (_cache[9] = _withModifiers((...args) => (_ctx.sendMessage && _ctx.sendMessage(...args)), ["prevent"])),
          "aria-label": "Send Message",
          tabindex: "0"
        }, _cache[15] || (_cache[15] = [
          _createElementVNode("svg", {
            width: "30",
            height: "30",
            xmlns: "http://www.w3.org/2000/svg",
            "aria-hidden": "true",
            viewBox: "0 0 30 30"
          }, [
            _createElementVNode("path", {
              d: "M15 30C6.716 30 0 23.284 0 15 0 6.716 6.716 0 15 0c8.284 0 15 6.716 15 15 0 8.284-6.716 15-15 15zm1.038-19.192l2.213 2.637a.75.75 0 1 0 1.149-.964l-3.535-4.213A.748.748 0 0 0 15.288 8a.748.748 0 0 0-.577.268l-3.536 4.213a.75.75 0 0 0 1.15.964l2.213-2.637v10.445a.75.75 0 1 0 1.5 0V10.808z",
              fill: "#B4B4B4",
              "fill-rule": "evenodd"
            })
          ], -1 /* HOISTED */)
        ]), 2 /* CLASS */)
      ], 2 /* CLASS */)
    ], 32 /* NEED_HYDRATION */)
  ], 2 /* CLASS */))
}